import { CartAddEvent } from '@theme/events';

const pairingSessionKey = 'laffrey:cart-pairing-openings:v1';
let pairingOpenings = 0;
let cartWasOpen = false;
let hidePairingsThisOpening = false;
try {
  pairingOpenings = Math.max(0, Number(sessionStorage.getItem(pairingSessionKey)) || 0);
} catch {}
const syncPairingVisibility = () => {
  const cartIsOpen = Boolean(document.querySelector('.cart-drawer__dialog[open]'));
  if (cartIsOpen && !cartWasOpen) {
    pairingOpenings += 1;
    hidePairingsThisOpening = pairingOpenings > 2;
    try { sessionStorage.setItem(pairingSessionKey, String(pairingOpenings)); } catch {}
  }
  cartWasOpen = cartIsOpen;
  document.documentElement.toggleAttribute('data-laffrey-hide-pairings',
    cartIsOpen ? hidePairingsThisOpening : pairingOpenings >= 2);
};
const pairingVisibilityObserver = new MutationObserver(syncPairingVisibility);
pairingVisibilityObserver.observe(document.documentElement, {
  subtree: true, childList: true, attributes: true, attributeFilter: ['open'],
});
syncPairingVisibility();

class LaffreyCartPairing extends HTMLElement {
  connectedCallback() {
    this.addEventListener('submit', this.handleSubmit);
    this.addEventListener('change', this.handleVariantChange);
  }

  disconnectedCallback() {
    this.removeEventListener('submit', this.handleSubmit);
    this.removeEventListener('change', this.handleVariantChange);
  }

  handleVariantChange = (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || select.name !== 'id') return;
    const price = select.selectedOptions[0]?.dataset.price;
    const display = this.querySelector('[data-pairing-price]');
    if (price && display) display.textContent = price;
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    if (this.hasAttribute('aria-busy')) return;
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.reportValidity()) return;
    const button = form.querySelector('button[type="submit"]');
    const error = form.querySelector('[role="alert"]');
    error.hidden = true;
    error.textContent = '';
    const body = new FormData(form);
    const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map((element) => element.dataset.sectionId))];
    body.set('sections', sections.slice(0, 5).join(','));
    body.set('sections_url', window.location.pathname);
    this.setAttribute('aria-busy', 'true');
    button.disabled = true;
    try {
      const response = await fetch(form.action + '.js', { method: 'POST', body, headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || this.dataset.errorMessage);
      document.dispatchEvent(new CartAddEvent({}, String(body.get('id')), {
        source: 'product-form-component',
        itemCount: 1,
        productId: this.dataset.productId,
        sections: result.sections,
      }));
    } catch (failure) {
      error.textContent = failure instanceof TypeError ? this.dataset.errorMessage : failure.message || this.dataset.errorMessage;
      error.hidden = false;
    } finally {
      this.removeAttribute('aria-busy');
      button.disabled = false;
    }
  };
}

if (!customElements.get('laffrey-cart-pairing')) customElements.define('laffrey-cart-pairing', LaffreyCartPairing);
